<script>
  import { Router, Route, link, useLocation, navigate } from "svelte-navigator";
  import Form from "./components/Form.svelte";
  import Calculate from "./components/Calculate.svelte";
  import Horoscope from "./components/Horoscope.svelte";
  import Aspects from "./components/Aspects.svelte";
  import MidpointsPlanet from "./components/MidpointsPlanet.svelte";
  import MidpointsSign from "./components/MidpointsSign.svelte";
  import MidpointsTree from "./components/MidpointsTree.svelte";
  import MirrorPoints from "./components/MirrorPoints.svelte";
  import Progressions from "./components/Progressions.svelte";
  import ProgressionsCurrent from "./components/ProgressionsCurrent.svelte";
  import Transits from "./components/Transits.svelte";
  import TransitsCurrent from "./components/TransitsCurrent.svelte";
  import Navigation from "./components/Navigation.svelte";
  import Header from "./components/Header.svelte";
  import Footer from "./components/Footer.svelte";
  import Login from "./components/UserLogin.svelte";
  import { user } from "./stores/user.js"; // Your user store
  import { formData } from "./stores/formData.js";
  import { showResultSection } from "./stores/showResultSection.js";
  import List from "./components/UserList.svelte";
  let showLogin = false;
  let showList = false;

  const openLogin = () => {
    showLogin = true;
  };
  const openList = async () => {
    // make the function async
    showList = true;
  };

  const closeLogin = () => {
    showLogin = false;
  };
  const closeList = () => {
    showList = false;
  };

  const logout = () => {
    $user = {}; // Empty the user object in the store
    // empty store "formData"
    formData.update(() => ({
      id: "",
      name: "",
      date: "",
      time: "",
      location: "",
      isSet: true,
      isInitiated: false,
      reset: false,
    }));
    showResultSection.set(false); // must be false always at start.
    // redirect to start page
    navigate("/");
  };
</script>

<Login show={showLogin} on:close={closeLogin} />
{#if List && showList}
  <!-- Check if List is not null before rendering -->
  <List show={showList} on:close={closeList} />
{/if}
<div class="main-content">
  <div class="UserMenu not-print">
    {#if $user && $user.loggedIn}
      <div class="leftContainer">
        <span class="welcome">Welkom {$user.name}!</span>
      </div>
      <div class="rightContainer">
        <button on:click={openList}>Lijst met opgeslagen horoscopen</button>
        <button on:click={logout}>Uitloggen</button>
      </div>
    {:else}
      <div class="leftContainer" />
      <div class="rightContainer">
        <button on:click={openLogin}
          >Inloggen om horoscopen te kunnen opslaan</button
        >
      </div>
    {/if}
  </div>

  <Header />

  <Router>
    <Route path="/"><Form /></Route>
    <Route path="/calculate"><Calculate /></Route>
    <Route path="/horoscope"><Horoscope /></Route>
    <Route path="/aspects"><Aspects /></Route>
    <Route path="/midpointsPlanet"><MidpointsPlanet /></Route>
    <Route path="/midpointsSign"><MidpointsSign /></Route>
    <Route path="/midpointsTree"><MidpointsTree /></Route>
    <Route path="/mirror-points"><MirrorPoints /></Route>
    <Route path="/progressions"><Progressions /></Route>
    <Route path="/progressionsCurrent"><ProgressionsCurrent /></Route>
    <Route path="/transits"><Transits /></Route>
    <Route path="/transitsCurrent"><TransitsCurrent /></Route>
    <Route path="/navigation"><Navigation /></Route>
    <Route path="/userlogin"><Login /></Route>
    <Route path="/userlist"><List /></Route>
  </Router>

  <Footer />
</div>

<style>
  .main-content {
    margin: 0 auto;
    max-width: 650px;
    padding: 1rem;
    padding-top: 0rem;
    border-radius: 5px;
  }
  :global(.container, .result-container, header, footer, .UserMenu) {
    position: relative;
    margin: 0 auto;
    max-width: 650px;
    background-color: whitesmoke;
    padding: 1rem;
    border-radius: 5px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    margin-top: 5px;
    margin-bottom: 5px;
  }
  :global(.strike) {
    text-decoration: line-through;
  }
  :global(table) {
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 0.5rem;
    font-size: small;
  }

  :global(table tr:nth-child(even)) {
    background-color: #f2f2f2;
  }

  :global(table tr:hover) {
    background-color: #ddd;
  }

  :global(th, td) {
    text-align: left;
    border-bottom: 1px solid #ddd;
    padding-right: 0.5em;
    padding-top: 0;
    padding-bottom: 0;
  }

  :global(h3) {
    margin-bottom: 12px;
  }

  :global(.planeet) {
    font-weight: bold;
  }

  :global(.astro-font) {
    font-family: "Astro", Arial, sans-serif;
  }

  .UserMenu {
    padding: 5px;
    font-size: small;
    display: flex;
    justify-content: space-between;
  }
  .leftContainer {
    align-self: flex-start;
    align-items: center;
    padding: 5px, 0px;
  }

  .rightContainer {
    align-self: flex-end;
    display: flex;
    gap: 10px; /* This adds a little space between your buttons */
  }
  .welcome {
    font-size: medium;
    margin: 10px 0px 0px 10px;
  }

  @media print {
    .not-print {
      display: none;
    }
  }
</style>
